import { render, staticRenderFns } from "./SignInputNavigationComponent.vue?vue&type=template&id=a27f8816&scoped=true&"
import script from "./SignInputNavigationComponent.vue?vue&type=script&lang=js&"
export * from "./SignInputNavigationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27f8816",
  null
  
)

export default component.exports